import { Component, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { QuillModule } from "ngx-quill";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-b12",
  imports: [FormsModule, ReactiveFormsModule, QuillModule],
  templateUrl: "./prefix-b12.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-b12.component.less",
})
export class PrefixB12Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 7000;
    this.characters = ALLOWED_CHARACTERS["b12"];
  }

  public onChange(e: string | null): void {
    this.control.markAsDirty();
    this.control.setValue(e);
  }
}
